import { SystemFuncArgs } from '@brochington/ecstatic';
import MoveLineCPInteraction from 'editor/components/interactions/MoveLineCPInteraction';
import Markup from 'editor/components/Markup';
import MarkupKit from 'editor/components/MarkupKit';
import { Components } from '../components';

export const moveLineControlPointComponents = [
  MarkupKit,
  Markup,
  MoveLineCPInteraction,
];

export function moveLineControlPoint(args: SystemFuncArgs<Components>): void {
  const { components } = args;
  const mc = components.get(Markup);

  const { MKPoint } = components.get(MarkupKit);
  const interaction = components.get(MoveLineCPInteraction);

  const { mkMarkup } = mc;

  if (!mkMarkup) {
    return;
  }

  const { pointIndex, currentX, currentY } = interaction;

  const point = new MKPoint(currentX, currentY);

  mkMarkup.setPoint(point, pointIndex);
}
